import { useTranslations } from '@npco/common-utils-translations'
import { Box } from '@npco/zeller-design-system'

import { selectCardTypeFormTranslations } from '../SelectCardTypeForm.i18n'

export const ExpenseCardDescription = () => {
  const t = useTranslations(selectCardTypeFormTranslations)

  return (
    <Box mr="20px">
      {t('expenseCardOptionDesc')}
      <br />
      {t('expenseCardOptionDescFreeTrailEnds')}
    </Box>
  )
}
